import type { Template } from "@/types";

export const LA_06_H0_V6: Template[] = [
    {
        id: "la-06-h0v6-01",
        name: "LA 01 - H0V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h0_v6_01.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 133, y: 53, width: 262, height: 424, rotation: 0, imageRotation: 0 },
            { id: "2", x: 403, y: 53, width: 140, height: 208, rotation: 0, imageRotation: 0 },
            { id: "3", x: 403, y: 269, width: 140, height: 208, rotation: 0, imageRotation: 0 },
            { id: "4", x: 810, y: 53, width: 261, height: 424, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1079, y: 53, width: 140, height: 208, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1079, y: 269, width: 140, height: 208, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h0v6-02",
        name: "LA 02 - H0V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h0_v6_02.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 133, y: 53, width: 143, height: 208, rotation: 0, imageRotation: 0 },
            { id: "2", x: 133, y: 269, width: 143, height: 208, rotation: 0, imageRotation: 0 },
            { id: "3", x: 284, y: 53, width: 259, height: 424, rotation: 0, imageRotation: 0 },
            { id: "4", x: 810, y: 53, width: 261, height: 424, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1079, y: 53, width: 140, height: 208, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1079, y: 269, width: 140, height: 208, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h0v6-03",
        name: "LA 03 - H0V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h0_v6_03.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 107, y: 85, width: 227, height: 359, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 85, width: 226, height: 359, rotation: 0, imageRotation: 0 },
            { id: "3", x: 821, y: 53, width: 261, height: 424, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1090, y: 53, width: 101, height: 136, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1090, y: 198, width: 101, height: 135, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1090, y: 342, width: 101, height: 135, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h0v6-04",
        name: "LA 04 - H0V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h0_v6_04.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 42, y: 114, width: 192, height: 303, rotation: 0, imageRotation: 0 },
            { id: "2", x: 242, y: 114, width: 192, height: 303, rotation: 0, imageRotation: 0 },
            { id: "3", x: 442, y: 114, width: 191, height: 303, rotation: 0, imageRotation: 0 },
            { id: "4", x: 719, y: 114, width: 192, height: 303, rotation: 0, imageRotation: 0 },
            { id: "5", x: 919, y: 114, width: 191, height: 303, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1118, y: 114, width: 191, height: 303, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h0v6-05",
        name: "LA 05 - H0V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h0_v6_05.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 98, width: 219, height: 336, rotation: 0, imageRotation: 0 },
            { id: "2", x: 227, y: 98, width: 219, height: 336, rotation: 0, imageRotation: 0 },
            { id: "3", x: 454, y: 98, width: 219, height: 336, rotation: 0, imageRotation: 0 },
            { id: "4", x: 681, y: 98, width: 219, height: 336, rotation: 0, imageRotation: 0 },
            { id: "5", x: 908, y: 98, width: 218, height: 336, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1134, y: 98, width: 218, height: 336, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h0v6-06",
        name: "LA 06 - H0V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h0_v6_06.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 42, y: 197, width: 192, height: 292, rotation: 0, imageRotation: 0 },
            { id: "2", x: 242, y: 197, width: 191, height: 292, rotation: 0, imageRotation: 0 },
            { id: "3", x: 441, y: 197, width: 191, height: 292, rotation: 0, imageRotation: 0 },
            { id: "4", x: 718, y: 197, width: 192, height: 292, rotation: 0, imageRotation: 0 },
            { id: "5", x: 918, y: 197, width: 191, height: 292, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1117, y: 197, width: 191, height: 292, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h0v6-07",
        name: "LA 07 - H0V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h0_v6_07.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 362, height: 531, rotation: 0, imageRotation: 0 },
            { id: "2", x: 521, y: 40, width: 152, height: 222, rotation: 0, imageRotation: 0 },
            { id: "3", x: 521, y: 270, width: 152, height: 222, rotation: 0, imageRotation: 0 },
            { id: "4", x: 681, y: 40, width: 152, height: 222, rotation: 0, imageRotation: 0 },
            { id: "5", x: 681, y: 270, width: 152, height: 222, rotation: 0, imageRotation: 0 },
            { id: "6", x: 990, y: 0, width: 362, height: 531, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h0v6-08",
        name: "LA 08 - H0V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h0_v6_08.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 364, height: 531, rotation: 0, imageRotation: 0 },
            { id: "2", x: 437, y: 40, width: 162, height: 221, rotation: 0, imageRotation: 0 },
            { id: "3", x: 437, y: 269, width: 162, height: 221, rotation: 0, imageRotation: 0 },
            { id: "4", x: 754, y: 40, width: 162, height: 221, rotation: 0, imageRotation: 0 },
            { id: "5", x: 754, y: 269, width: 162, height: 221, rotation: 0, imageRotation: 0 },
            { id: "6", x: 988, y: 0, width: 364, height: 531, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h0v6-09",
        name: "LA 09 - H0V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h0_v6_09.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 68, y: 79, width: 124, height: 185, rotation: 0, imageRotation: 0 },
            { id: "2", x: 68, y: 271, width: 124, height: 184, rotation: 0, imageRotation: 0 },
            { id: "3", x: 200, y: 79, width: 279, height: 376, rotation: 0, imageRotation: 0 },
            { id: "4", x: 487, y: 79, width: 121, height: 185, rotation: 0, imageRotation: 0 },
            { id: "5", x: 487, y: 271, width: 121, height: 184, rotation: 0, imageRotation: 0 },
            { id: "6", x: 968, y: 0, width: 384, height: 531, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h0v6-10",
        name: "LA 10 - H0V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h0_v6_10.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 376, height: 531, rotation: 0, imageRotation: 0 },
            { id: "2", x: 739, y: 79, width: 279, height: 376, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1026, y: 79, width: 129, height: 185, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1026, y: 271, width: 129, height: 184, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1163, y: 79, width: 129, height: 185, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1163, y: 271, width: 129, height: 184, rotation: 0, imageRotation: 0 }
        ],
    }
];